import { StyleSheet, Text, View } from 'react-native'
import React, { useEffect } from 'react'
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader'
import { ThemedView } from '@app/theme'

const KYCAutoRedirect = ({ autoCallback }: { autoCallback: () => void }) => {

    useEffect(() => {
        setTimeout(() => {
            autoCallback()
            // take a small buffer to navigate
        }, 100)
    }, [])

    return (
        <ThemedView flex={1}>
            <PageLoader />
        </ThemedView>
    )
}

export default KYCAutoRedirect

const styles = StyleSheet.create({})